import { render } from "./CompetitionsListItem.vue?vue&type=template&id=99dc8752&scoped=true"
import script from "./CompetitionsListItem.vue?vue&type=script&lang=js"
export * from "./CompetitionsListItem.vue?vue&type=script&lang=js"

import "./CompetitionsListItem.vue?vue&type=style&index=0&id=99dc8752&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99dc8752"]])

export default __exports__